module.exports = __webpack_public_path__ + "static/media/FB_desktop.0a56cec4.svg";